import React, { useState, useEffect, useRef } from 'react';
import { supabase } from '../supabaseClient';
import '../styles/Munfaridat.css';

/* ════════════════════════════════════════════════════════════
   MUNFARIDAT — قصائد منفردة (standalone poems)
   Fetched from Supabase with hardcoded fallback.
   ════════════════════════════════════════════════════════════ */

const POEMS = [
  {
    id: 'mn-hamsa',
    title: 'هَمْسَةٌ فِي الهَوَى',
    category: 'غزل',
    verses: [
      'يَا أجْمَلَ أجْمَلَ وَرْدَاتِي',
      'يَا شَوْقًا ضَجَّ بِنَهْدَاتِي',
      'أأقُولُ شَغَافُكِ أضْنَانِي',
      'وَالعِشْقُ تَسَنْبَلَ فِي ذَاتِي',
      'أَأَبُوحُ بِسِرِّي فِي لَيْلٍ',
      'غَفَّاهُ اللَّحظُ بِجَفْنَاتِي',
      'أَأَقُولُ اشْتَقْتُ لِفَاتِنَتِي',
      'والكُلُّ يُرَاقِبُ لَفْتَاتِي',
      'فَأنَا، بِالضَّوءِ أفِيضُ رُؤًى',
      'لَمْعًا مِن زُرْقَةِ نَجْمَاتِي',
      'أَأَبُوحُ بِحُبِّكِ يَا قَمَرِي',
      'وَجَمَالُكِ أشْقَى الحُلْوَات',
      'وَخَيَالُكِ زَوْرَقُ أَحْلامِي',
      'كَمْ دَارَتْ فِيهِ مَدَارَاتِي',
      '',
      'يَا سِحْرًا، يُغْوِينِي صُبْحًا',
      'وَمَسَاءً!!.. يَرْسُمُ آهَاتِي',
      'أَودَعْتُ النُّورَ قَنَادِيلِي',
      'تَشْدُو مَعْ طَيرِ الغَابَات',
      'لأُقِرَّ اليَومَ بِإحْسَاسٍ',
      'أجَّ الهَمَسَاتِ بِنَايَاتِي',
      'فَسَأَبْقَى، أقْطُرُ تَرْيَاقًا',
      'وَسَأَحْيَا طَيْفَكِ فِي ذَاتِي',
      'يَا أَوَّلَ حُلْمٍ يَسْكَنَنِي',
      'وَلآخِرِ نَبْضٍ فِي الآتِي',
    ],
  },
  {
    id: 'mn-hiwar',
    title: 'حِوَارُ العُشَّاقِ',
    category: 'غزل',
    verses: [
      'قَالَتْ لَهُ أَتُحِبُّنِي ؟؟.. فَاحْتَارَا',
      'وَالعِشْقُ صَارَ وَلِيفَهُ.. وَشِعَارَا',
      'وَتَلَعْثَمَتْ فِيهِ الشُّكُوكُ، وَقَلْبُهُ',
      'مَا زَالَ يَكْتُبُ صَمْتَهُ.. أَسْرَارَا',
      'الحُبُّ لَيْسَ يُقَالُ، بَلْ نَحْيَا بِهِ',
      'مَنْ ذَاقَهُ، أَدْرَى الهَوَى.. وَأَثَارَا',
      'فَتَجَمْهَرَتْ كَلِمَاتُهُ فِي بَوحِهِ',
      'بِمَدًى، وَفَوقَ مَدَارِهِ قَد دَارَا',
      'ثُمَّ اهْتَدَى!! جَمَعَ الحُرُوفَ وَصَانَهَا',
      'وَمَضَى، يُلَمْلِمُ وَحْدَهُ الأفْكَارَا',
      'وَغَدَا الكَلامُ يَضِجُّ فِي أوْصَالِه',
      'لِتَخَالَهُ، لا يَأبَهُ الإعْصَارا',
      'فَأَجَابَهَا، وَالهَمْسُ كَانَ لِسَانَهُ',
      'إنِّي أُحِبُّكِ،.. فَاسْتَرَاحَ وَغَارَا',
      'وَتَلَاقَتِ الأَرْوَاحُ بَعْدَ تَبَاعُدٍ',
      'فَغَدَا الهَوَى فِي قَلْبِهِمْ أَنْوَارَا',
      'وَتَبَدَّدَتْ كُلُّ الظُّنُونِ بِلَحْظَةٍ',
      'وَتَنَفَّسَتْ أَحْلَامُهُمْ أَقْمَارَا',
      'فَكَأَنَّهُ بِالإِعْتِرَافِ نَدَا الهَوَى',
      'وَتَحَوَّلَ اللَّيلُ البَهِيمُ نَهَارَا',
    ],
  },
];

/* ════════════════════════════════════════════════════════════ */

export default function Munfaridat() {
  const [poems, setPoems] = useState(POEMS);
  const [openId, setOpenId] = useState(null);
  const [revealed, setRevealed] = useState(new Set());
  const cardRefs = useRef({});

  /* Fetch from Supabase */
  useEffect(() => {
    const fetchPoems = async () => {
      try {
        const { data, error } = await supabase
          .from('munfaridat')
          .select('*')
          .order('sort_order', { ascending: true });

        if (error) throw error;

        if (data && data.length > 0) {
          setPoems(data.map(p => ({
            id: p.id,
            title: p.title,
            category: p.category,
            verses: p.verses.split('\n'),
          })));
        }
      } catch (_) {
        // Keep fallback POEMS
      }
    };

    fetchPoems();

    const channel = supabase
      .channel('munfaridat_changes')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'munfaridat' }, () => {
        fetchPoems();
      })
      .subscribe();

    return () => { supabase.removeChannel(channel); };
  }, []);

  /* Scroll-reveal — re-run when poems change */
  useEffect(() => {
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => {
        if (e.isIntersecting) setRevealed(p => new Set([...p, e.target.dataset.pid]));
      }),
      { threshold: 0.1 }
    );
    // Small delay to ensure refs are attached after render
    const timer = setTimeout(() => {
      Object.values(cardRefs.current).forEach(el => el && obs.observe(el));
    }, 100);
    return () => { clearTimeout(timer); obs.disconnect(); };
  }, [poems]);

  const toggle = (id) => setOpenId(openId === id ? null : id);

  return (
    <section id="munfaridat" className="mf-section">
      {/* Ambient */}
      <div className="mf-ambient" aria-hidden="true">
        <b>ق</b><b>ص</b><b>د</b>
      </div>

      <div className="mf-container">

        {/* Header */}
        <header className="mf-header">
          <span className="mf-eyebrow">خارج الدواوين</span>
          <h2 className="mf-title">قصائد متنوعة</h2>
          <div className="mf-rule"><span /><em>◆</em><span /></div>
          <p className="mf-sub">
            قصائد مستقلّة لم تُضمّ إلى ديوان — نوافذ حرّة على عوالم الشاعر
          </p>
        </header>

        {/* Poems */}
        <div className="mf-grid">
          {poems.map((poem, idx) => {
            const isOpen = openId === poem.id;
            const previewLines = 4;
            const displayVerses = isOpen ? poem.verses : poem.verses.slice(0, previewLines);
            const hasMore = poem.verses.length > previewLines;

            return (
              <article
                key={poem.id}
                ref={el => { cardRefs.current[poem.id] = el; }}
                data-pid={poem.id}
                className={`mf-card ${revealed.has(poem.id) ? 'mf-card--in' : ''} ${isOpen ? 'mf-card--open' : ''}`}
                style={{ '--delay': `${idx * 120}ms` }}
              >
                {/* Top accent */}
                <div className="mf-card-accent" />

                {/* Header */}
                <div className="mf-card-head">
                  <span className="mf-card-cat">{poem.category}</span>
                  <span className="mf-card-author">وجدي عبد الصمد</span>
                </div>

                {/* Title */}
                <h3 className="mf-card-title">{poem.title}</h3>
                <div className="mf-card-hr" />

                {/* Verses */}
                <div className={`mf-card-verses ${isOpen ? 'mf-card-verses--open' : ''}`}>
                  {displayVerses.map((line, i) => (
                    line === '' ? (
                      <div key={i} className="mf-verse-break" />
                    ) : (
                      <p key={i} className="mf-verse">{line}</p>
                    )
                  ))}
                  {!isOpen && hasMore && <div className="mf-verses-veil" />}
                </div>

                {/* Toggle */}
                {hasMore && (
                  <button className="mf-toggle" onClick={() => toggle(poem.id)}>
                    {isOpen ? '▲ إخفاء' : '▼ القصيدة كاملة'}
                  </button>
                )}

                {/* Decorative quote mark */}
                <div className="mf-card-quote" aria-hidden="true">«</div>
              </article>
            );
          })}
        </div>

        {/* Bottom ornament */}
        <div className="mf-ornament">
          <span /><em>✦ ✦ ✦</em><span />
        </div>
      </div>
    </section>
  );
}